var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTri(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50008 25C2.04256 25 1.58755 24.875 1.18504 24.6275C0.822963 24.4028 0.52414 24.0896 0.316791 23.7173C0.109442 23.345 0.000412138 22.9261 0 22.5V2.4996C0 1.63208 0.450014 0.827067 1.18504 0.372059C1.54791 0.148957 1.96156 0.0218076 2.3871 0.00256459C2.81264 -0.0166784 3.23608 0.0726173 3.61761 0.262057L23.6182 10.2622C24.0335 10.4702 24.3827 10.7897 24.6267 11.1849C24.8707 11.58 25 12.0353 25 12.4998C25 12.9642 24.8707 13.4195 24.6267 13.8147C24.3827 14.2098 24.0335 14.5293 23.6182 14.7373L3.61761 24.7375C3.2676 24.9125 2.88009 25 2.50008 25Z",
    fill: "#870003"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTri);
export default __webpack_public_path__ + "static/media/Tri.7698843f803f84f1af881b53b193196a.svg";
export { ForwardRef as ReactComponent };